module.exports = __webpack_public_path__ + "static/media/matched-compare.b38c9630.svg";